var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParentsRoominline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 32.5,
  cy: 14.5,
  r: 5.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.493 31.268 39 37H26q.176-3.18.288-5.549l-6.403 4.8c-1.316.986-3.216.763-4.244-.5s-.795-3.085.521-4.072l10.732-8.045q.281-.21.592-.347.495-.287 1.236-.287h7.033q.131 0 .254.009a3.1 3.1 0 0 1 2.097.606l10.732 8.045c1.316.987 1.549 2.81.521 4.072s-2.928 1.486-4.244.5zm-18.45 13.959-.006-.006L25.636 40l4.49 4.815-3.243 3.024 3.41 3.656a3.239 3.239 0 1 1-4.738 4.418l-5.685-6.096a3.24 3.24 0 0 1 .173-4.59zm25.077 0 .006-.006L39.527 40l-4.49 4.815 3.243 3.024-3.41 3.656a3.239 3.239 0 1 0 4.738 4.418l5.685-6.096a3.24 3.24 0 0 0-.173-4.59z"
}))));
export default SvgParentsRoominline;